import { UrlBuilder } from '@common/utils/urlBuilder';

type QueryParams<T extends object> = T;

export function getUrlQueryParameters<T extends object>(url: string, queryParams?: QueryParams<T>): string {
    const urlBuilder = new UrlBuilder(url);

    if (!queryParams) {
        return url;
    }

    for (const [key, value] of Object.entries(queryParams)) {
        if (typeof value !== 'undefined' && value !== null) {
            urlBuilder.add(key, value);
        }
    }

    return urlBuilder.build();
}
